import { createFileRoute } from "@tanstack/react-router";
import { CloudflareConnection } from "@/components/cloudflare/connection";
import { SubPage } from "@/components/page/page";

export const Route = createFileRoute("/settings/cloudflare")({
  component: CloudflareSettings,
});

function CloudflareSettings() {
  return (
    <SubPage
      title="Cloudflare"
      parent="Settings"
      description="Minket writes and repairs your domains' records on these zones, and never changes one it did not create."
    >
      <CloudflareConnection />
    </SubPage>
  );
}
